module.exports = "/assets/5295b21a51bb00722f556cd6a58bf925.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UO.png
// module id = 3017
// module chunks = 0